import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-custom-phone-number'
})
export class Ng1CustomPhoneNumberDirective extends UpgradeComponent {
  @Input() msisdn;
  @Input() plan;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('customNumber', elementRef, injector);
  }
}
